var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPilot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}.cls-2{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.22,64.24a4.22,4.22,0,0,1-.49.4c-2.12-1.49-4.15-3.07-6.33-4.42-6.53-4-13.77-6.14-21.28-7.31a116.1,116.1,0,0,0-31-.61c-11.83,1.32-23,4.36-32.32,12.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.32,88.64c-12-.42-24.07-.73-35.77-3.56a32,32,0,0,1-7.78-3c-3.25-1.77-3.52-3.76-1.12-6.44,3.52-3.92,8.33-6.19,13.38-8a78.24,78.24,0,0,1,21.79-4.18c11.39-.7,22.74-.41,33.88,2.22,6.59,1.55,12.77,3.88,18.05,7.94,5.07,3.89,4.83,7.55-1.34,9.66A79.51,79.51,0,0,1,136,87c-8.16,1-16.42,1.16-24.64,1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.6,64.92C57.34,60.25,56,51.53,58.78,46.1c4.15-7.94,9.8-12.55,15.75-16.24a59.39,59.39,0,0,1,25.64-8.47c13.4-1.43,26.75-.83,39.86,4.49A48.35,48.35,0,0,1,161.27,42c6,7.89,4.13,17.73-4.12,22.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.71,84.26a40,40,0,1,1-77.53.43"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 101.37,
    cy: 100.22,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 121.72,
    cy: 100.22,
    r: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "88.73 35.93 102.95 35.93 110.23 41.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "131.84 35.93 117.62 35.93 110.34 41.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "111.64 201.43 150.74 158.86 142.49 137.58 111.64 151.04 101.44 162.88 109.25 173.63 102.74 189.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "111.21 201.43 72.11 158.86 80.37 137.58 111.21 151.04 121.42 162.88 113.6 173.63 120.11 189.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilot);
export default __webpack_public_path__ + "static/media/PILOT.2fb8b144bb9ee3ef8a6f350322237166.svg";
export { ForwardRef as ReactComponent };